import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import userSlice from "./slices/userSlice";
import playerPointsModalSlice from "./slices/playerPointsModalSlice";
import languageSlice from "./slices/languageSlice";

const rootReducer = combineReducers({
  userSlice: userSlice.reducer
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: {
    persisted: persistedReducer,
    playerPointsModalSlice: playerPointsModalSlice.reducer,
    languageSlice: languageSlice.reducer,

  },
});

export default store;
export const persistor = persistStore(store);